<template>
  <div v-if="type !== 'rkz'" class="accardion-content accardion-content-active">
    <div class="policy-accardion-items-header">
      <div class="policy-accardion-items-title" style="width: 40%;">Название</div>
      <div class="policy-accardion-items-title" style="width: 30%;">Страховая сумма</div>
      <div v-show="productType !== 'pf'" class="policy-accardion-items-title" style="width: 30%;">Страховая премия</div>
    </div>
    <div v-for="(risk, key) in risksComputed" :key="key" class="policy-accardion-items">
      <div class="policy-accardion-items-text" style="width: 40%;">{{ risk.name }}</div>
      <div v-if="typeof risk.amount_p === 'undefined' || !project_visible" class="policy-accardion-items-text"
           style="width: 30%;">{{ risk.amount }}
      </div>
      <div v-if="typeof risk.amount_p !== 'undefined' && project_visible" class="policy-accardion-items-text alert-info"
           style="width: 30%;">{{ risk.amount_p }}
      </div>
      <div v-show="productType !== 'pf'" class="policy-accardion-items-text" style="width: 30%;">{{ risk.premium }}
      </div>
    </div>
  </div>
  <div v-if="type === 'rkz'" class="accardion-content accardion-content-active">
    <div class="policy-accardion-items-header">
      <div class="policy-accardion-items-title" style="width: 60%;">Название</div>
      <div class="policy-accardion-items-title" style="width: 40%;">Страховая сумма</div>
    </div>
    <div v-for="(risk, key) in risksComputed" :key="key" class="policy-accardion-items">
      <div class="policy-accardion-items-text" style="width: 60%;">{{ risk.name }}</div>
      <div v-if="typeof risk.amount_p === 'undefined' || !project_visible" class="policy-accardion-items-text"
           style="width: 40%;">
        {{ risk.amount }}
        <p v-if="risk.risk_id && risk.risk_id === '42044'">на каждого застрахованного</p>
      </div>
      <div v-if="typeof risk.amount_p !== 'undefined' && project_visible" class="policy-accardion-items-text alert-info"
           style="width: 40%;">{{ risk.amount_p }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RisksComponent",
  props: ["risks", "project_visible", "project_state", "type", "productType"],
  computed: {
    risksComputed() {
      if (this.productType === "pf") { // продукт Инвестор / ПИФ (графики в ДСЖ)
        return this.risks.filter(el => el.name !== "Остаток взноса ДСЖ" && el.name !== "Взнос в инвестиционный фонд ДСЖ");
      } else {
        return this.risks;
      }
    }
  }
};
</script>

<style scoped>
.policy-accardion-items-text p {
  font-size: 12px !important;
}

@media only screen and (max-width: 579px) {
  .policy-accardion-items-text p {
    font-size: 8px !important;
  }
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
</style>
